import type { OpaqueCursorPagination } from './authorization.types';
import type { JsonValue } from './common.types';
import type { OpaqueCursorSearchRequest } from './omnisearch.types';

export type TransactionLogOperation = 'INSERT' | 'UPDATE' | 'DELETE';

export const TransactionLogTableNames = [
    'users',
    'organizations',
    'merchant_customer_records',
    'role_assignments',
    'single_use_auth_tokens',
    'totp_backup_codes',
    'ipw_customer_links',
    'payment_method_tokens',
    'stored_payment_methods',
    'credit_card_stored_payment_details',
    'debit_card_stored_payment_details',
    'ach_stored_payment_details',
    'payment_requests',
    'payment_request_delivery_events',
    'payment_request_documents',
    'document_templates',
    'payment_transactions',
    'payment_transaction_lifecycle_events',
    'credentials',
    'permissions_bundles',
    'permissions_policy_grants',
    'legal_documents',
    'user_legal_document_acceptances',
    'processors',
    'merchant_accounts',
    'logical_terminals',
    'terminal_devices',
    'allowed_website_templates',
    'organization_allowed_websites',
] as const;

export type TransactionLogTableName = (typeof TransactionLogTableNames)[number];

export interface TransactionLogListItem {
    transaction_log_ref: string;
    ts: string;
    table_name: TransactionLogTableName;
    operation: TransactionLogOperation;
    table_row: JsonValue;
    ip_address: string | null;
    user_agent: string | null;
}

export interface TransactionLogTablePrimaryKeyFilter {
    table_name: TransactionLogTableName;
    primary_key_values: string[];
}

export interface TransactionLogSearchRequest extends OpaqueCursorSearchRequest {
    tables?: TransactionLogTableName[];
    table_primary_keys?: TransactionLogTablePrimaryKeyFilter[];
}

export interface ListTransactionLogPageResponse {
    transaction_log: TransactionLogListItem[];
    pagination: OpaqueCursorPagination;
}
